import React, { useRef, useContext, useState, useEffect } from 'react';
import './styles.css'
import { useForm } from 'react-hook-form';
import * as FcIcons from 'react-icons/fc';

import AxiosService from '../services/axios.service';

const API_PATH = "requests";

function List(match) {
    const { path } = match;
    const [requests, setRequests] = useState(null);
    const [results, setResults] = useState(0);

    const { register, watch, formState: { errors }, handleSubmit } = useForm();

    function search() {
        var keyword = watch("query").toLowerCase();
        AxiosService.getAll(API_PATH).then(x => {
            var queries = x.data.filter(item => item.agency.toLowerCase().includes(keyword) || item.agency_tracking_numbers.toLowerCase().includes(keyword) || item.current_status.toLowerCase().includes(keyword) || item.subject.toLowerCase().includes(keyword) || item.short_description.toLowerCase().includes(keyword))
            setRequests(queries)
            setResults(queries.length)
        }
        );
    }

    useEffect(() => {
        let today = new Date().toISOString().slice(0, 10);
        AxiosService.getAll(API_PATH).then(x => {
            for (var j in x.data) {
                var agency_names_to_string = "";
                var agencies = x.data[j].agency;
                for (var i in agencies) {
                    console.log(agencies[i].name);
                    agency_names_to_string += agencies[i].name + " ";
                }
                console.log(agency_names_to_string);
                x.data[j].agencies = agency_names_to_string
            }
            var queries = x.data.filter(item => item.submission_date >= today)
            queries.sort((a, b) => new Date(a.submission_date) - new Date(b.submission_date));
            setRequests(queries)
            setResults(queries.length)
            console.log(queries);
        }
        );
    }, []);

    return (
        <div>
            <h1 style={{ textAlign: 'center' }}>Deadline</h1>
            <form onSubmit={handleSubmit(search)} onReset={useEffect}>
                <div className="form-row">
                    <div className="form-group col-5">
                        <input name="query" type="text" ref={register} {...register("query", {})} className={`form-control ${errors.query ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.query?.message}</div>
                    </div>
                    <div className="form-group col-5">
                        {/*<button onClick={search} style={{ marginRight: 8 }} class="btn btn-light" id="search">Search <FcIcons.FcSearch size={24} /></button>*/}
                        <button class="btn btn-light" type="submit">Search <FcIcons.FcSearch size={24} /></button>
                    </div>
                </div>
            </form>
            <h5>Results: {results}</h5>
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th style={{ width: '15%' }}>Agency</th>
                        <th style={{ width: '15%' }}>Short Description</th>
                        <th style={{ width: '15%' }}>Current Status</th>
                        <th style={{ width: '15%' }}>Submission Date</th>
                        <th style={{ width: '15%' }}>Acknowledgement Date</th>
                    </tr>
                </thead>
                <tbody>
                    {requests && requests.map(request =>
                        <tr key={request.id}>
                            <td>{request.agency}</td>
                            <td>{request.short_description}</td>
                            <td>{request.current_status}</td>
                            <td>{request.submission_date}</td>
                            <td>{request.acknowledgement_date}</td>
                        </tr>
                    )}
                    {!requests &&
                        <tr>
                            <td colSpan="4" className="text-center">
                                <div className="spinner-border spinner-border-lg align-center"></div>
                            </td>
                        </tr>
                    }
                    {requests && !requests.length &&
                        <tr>
                            <td colSpan="4" className="text-center">
                                <div className="p-2">No Users To Display</div>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    );
}

export { List };